module.exports = __webpack_public_path__ + "img/search-head.ebab3201.png";